import React from "react";
import PropTypes from 'prop-types';
import makeStyles from "@material-ui/core/styles/makeStyles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {TextField} from "@material-ui/core";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../Components/JsonScreen/Utils/lib";
import clsx from "clsx";

const useStyles = makeStyles(() => ({
    inputRoot: {
        paddingRight: '0 !important',
        '&[class*="MuiInput-root"]': {
            paddingRight: 0,
            '& $input': {
                padding: '4px 4px',
            },
        },
        '&[class*="MuiOutlinedInput-root"]': {
            paddingRight: '0',
            padding: '1px'
            // padding: '1px 35px 1px 1px !important'
        },
    },
    textFieldRoot: {
        '& .MuiInput-underline:before': {
            borderBottomColor: 'rgba(0,0,0,0.22)', // Semi-transparent underline
        },
    },
    option: {
        minHeight: 2,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'pointer',
        boxSizing: 'border-box',
        outline: '0',
        // WebkitTapHighlightColor: 'transparent',
        paddingTop: '1px !important',
        paddingBottom: '2px !important',
        paddingLeft: '16px !important',
        paddingRight: '16px important',
    },
    paper: {
        width: 'auto',
        '& > ul': {
            maxHeight: 200,
            overflow: 'auto',
        },
    },
    clearIndicator: {
        display: 'none',
    },
    tag: {
        height: '24px'
    },
    popupIndicator: {}
}));

const SimpleField = (props) => {
    const {
        fieldValue, onChange, required, disabled, onBlur, label, isMobile,
        fieldStyles, autofocus, error, fieldRef, type, minLength, maxLength, options,
        renderOptions, fieldPresentation, placeholder, field, screenName, path
    } = props;
    const classes = useStyles();
    const userLanguage = useSelector(state => state.app.userLanguage);
    const inputClassName = fieldStyles.withoutStyles ? 'horizontal-fields-table' : 'form-dynamic-default-select';
    const customStyles = (isMobile || fieldStyles.presentation === 'standard') ? {
            width: '100%',
            marginTop: 4
        } :
        {
            width: '100%',
            margin: fieldStyles.margin,
            paddingTop: fieldStyles.withoutPadding ? 0 : !isMobile && 3,
            paddingLeft: fieldStyles.withoutPadding ? 0 : !isMobile && 2,
        };
    return (
        <Autocomplete
            id={field.id}
            value={fieldValue !== undefined ? fieldValue : ''}
            onChange={onChange}
            disabled={disabled}
            classes={{
                inputRoot: classes.inputRoot,
                clearIndicator: classes.clearIndicator,
                option: classes.option,
                paper: classes.paper,
                tag: classes.tag,
                popupIndicator: classes.popupIndicator
            }}
            onBlur={onBlur}
            options={options}
            className={"sb-entity-external-field"}
            getOptionLabel={option => option && option?.label || ''}
            getOptionSelected={option => option?.label === fieldValue?.label}
            fullWidth={true}
            renderOption={(option) => (
                <>
                    {renderOptions ? renderOptions(option) : option && option?.label}
                </>
            )}
            renderInput={params =>
                <TextField
                    {...params}
                    name={path}
                    fullWidth={true}
                    autoFocus={autofocus}
                    placeholder={multiLanguageValue(placeholder, userLanguage)}
                    required={required && (fieldValue === null || !fieldValue.length)}
                    error={error.length > 0}
                    label={(isMobile || fieldStyles.presentation === 'standard') && multiLanguageValue(label, userLanguage)}
                    variant={isMobile ? 'standard' : fieldPresentation}
                    inputRef={fieldRef}
                    type={type}
                    className={clsx(inputClassName, "sb-field", screenName)}
                    classes={{root: classes.textFieldRoot}}
                    inputProps={{
                        ...params.inputProps,
                        style: {width: '100%', height: fieldStyles.height},
                        className: !fieldStyles.withoutStyles && 'with-styles',
                        minLength: minLength ? minLength : 1,
                        maxLength: maxLength ? maxLength : 100
                    }}
                    style={customStyles}
                />}
        />
    )
};

export default SimpleField;

SimpleField.propTypes = {
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    renderOptions: PropTypes.func,
    fieldValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array, PropTypes.object]),
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    fieldRef: PropTypes.any,
    isMobile: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    fieldStyles: PropTypes.object,
    error: PropTypes.string,
    autofocus: PropTypes.bool,
    type: PropTypes.string,
    minLength: PropTypes.string,
    maxLength: PropTypes.string
};

SimpleField.defaultProps = {
    fieldValue: '',
    fieldPresentation: 'outlined'
};